module.exports = __webpack_public_path__ + "img/pro_feature_export_expenses.bdd9b16.png";